import { Add } from '@mui/icons-material';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import QueryString from 'qs';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { useGetAllTasks } from '../../../services/react-query/tasks';
import { listPageTableRowStyling } from '../../../styles/sxStyling';
import { TaskItemQueryParams, TaskStatusFilter } from '../../../types/Task';
import { UserConfigurableModule, UserSettingsCollapseKeys } from '../../../types/User';
import ResponsiveButton from '../../../uikit/buttons/ResponsiveButton';
import AccordionSection from '../../AccordionSection';
import TaskStatusPill from '../../tasks/TaskStatusPill';
import TemplateModal from '../../tasks/TemplateModal/TemplateModal';
import AccountTaskFilter, { TaskStatusAccountFilter } from './AccountTaskFilter';
import DrawerLink from '../../common/drawers/ModuleDrawer/DrawerLink';

interface AccountTaskTableProps {
  accountUuid: string;
}
const AccountTaskTable = ({ accountUuid }: AccountTaskTableProps) => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [showTaskTemplateModal, setShowTaskTemplateModal] = useState<boolean>(false);
  const [taskStatus, setTaskStatus] = useState<TaskStatusAccountFilter>(TaskStatusFilter.ACTIVE);

  const filters = {
    account: [accountUuid],
    ...(taskStatus !== 'all' && { task_status: [taskStatus] }),
  };

  const { data: taskData } = useGetAllTasks({
    params: {
      per_page: 0,
      filters,
      sort: {
        due_date: 1,
      },
    },
  });
  const tasks = taskData?.data || [];

  const newWithTemplate = (templateUuid: string | null) => {
    const queryParams: TaskItemQueryParams = {
      account: uuid,
    };
    if (templateUuid) {
      queryParams.template = templateUuid;
    }
    const queryString = QueryString.stringify(queryParams);
    navigate(`/${ROUTE_PATHS.TASKS}/new?${queryString}`);
  };

  const taskTableHeaderElements = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <AccountTaskFilter value={taskStatus} onChange={setTaskStatus} />
      <ResponsiveButton startIcon={<Add />} variant="outlined" onClick={() => setShowTaskTemplateModal(true)}>
        Add
      </ResponsiveButton>
    </Box>
  );

  return (
    <AccordionSection
      title="Tasks"
      collapseId={UserSettingsCollapseKeys.ACCOUNT_ITEM_TASKS}
      headerElements={taskTableHeaderElements}
      hasData={tasks.length > 0}
    >
      <TableContainer sx={{ marginY: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Task Type</TableCell>
              <TableCell>Event Type</TableCell>
              <TableCell>DUE DATE</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tasks.map((task) => (
              <TableRow key={task.uuid} sx={{ ...listPageTableRowStyling }}>
                <TableCell>
                  <DrawerLink module={UserConfigurableModule.TASKS} uuid={task.uuid}>
                    {task.name}
                  </DrawerLink>
                </TableCell>
                <TableCell>{task.type_value}</TableCell>
                <TableCell>{task.parent_type}</TableCell>
                <TableCell>{task.due_date}</TableCell>
                <TableCell>
                  <TaskStatusPill status={task.status} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TemplateModal isOpen={showTaskTemplateModal} onCancel={() => setShowTaskTemplateModal(false)} onCreate={newWithTemplate} />
    </AccordionSection>
  );
};
export default AccountTaskTable;
